module.exports = "/next-static/_next/static/images/block_image_multiple_platforms-409addab37d7eedbc838633f410284e9.png";